<script>
// 选择工程师

import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
// import { getEngineer } from "@/helpers/common-service";
import _ from "lodash";
import {auditingEngineer, getCompanyEngineers, serviceCompany} from "@/service";

export default {
  props: {
    // 已选择的工程师
    value: {
      type: [Number, String],
      default: null
    },
    companyId: {
      type: Number,
      default: null
    },
    provinceId: {
      type: Number,
      default: 0
    },
    customerId: {
      type: Number,
      default: 0
    },
    excludeEngineerId: {
      type: Number,
      default: 0
    },
    // value字段，默认是id
    valueField: {
      type: String,
      default: 'id'
    },
    // 返回字段，默认返回id，如果要返回完整的工程师对象，传obj
    returnField: {
      type: String,
      default: 'id'
    },
    // 只有当有company时才查询数据
    getDataWhenHasCompany: {
      type: Boolean,
      default: true
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    placeholoderText: {
      type: String,
      default: ''
    },
    unbindAccount: {
      type: Boolean,
      default: false
    },
    engineerType:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      enginerrId: null,
      engineer: [],
    }
  },
  computed: {
    availableEngineer() {
      if (this.excludeEngineerId) {
        return _.filter(this.engineer, o => o.id != this.excludeEngineerId)
      }
      return this.engineer
    }
  },
  methods: {
    getEngineer(val) {
      this.engineer = []
      let params
      switch (val) {
        case '1':
          params = {
            type: 'sale',
            page_size: 0,
            province: this.provinceId
          }
          auditingEngineer(params).then(res => {
            this.engineer = res.payload
          })
          break;
        case '2':
          params = {
            type: 'technical',
            page_size: 0,
            province: this.provinceId
          }
          auditingEngineer(params).then(res => {
            this.engineer = res.payload
          })
          break;
        case '3':
          params = {
            page_size: 0,
            customer: this.customerId || undefined // 可选参数，不传查所有
          }
          serviceCompany(params).then(res => {
            this.engineer = res.payload
          })

          break;
        case '4':
          params = {
            page_size: 0,
            company: this.companyId
          }
          getCompanyEngineers(params).then(res => {
            this.engineer = res.payload
          })
          break;
      }
    },
    changeEngineer(value) {
      // console.log(this.enginerrId, value, 22222)
      if (this.returnField === 'id') {
        this.$emit('changed', value)
      }
      if (this.returnField === 'obj') {
        // 返回工程师对象
        const currentEngineer = _.find(this.engineer, ['id', value])
        this.$emit('changed', _.cloneDeep(currentEngineer))
      }
    }
  },
  components: {
    Multiselect,
  },
  watch: {
    engineerType: {
      immediate: true,
      handler(val) {
        console.log(val)
        this.enginerrId=null
        this.getEngineer(val)
      }
    },
    value: {
      immediate: true,
      handler(val) {
        if (this.valueField === 'id') {
          this.enginerrId = val

          // 莫名其妙的组件-这里设置了选中值，但是触发change事件-changeEngineer事件的参数却无值，这里来个nextTick将值改回来。。。。
          // console.log(this.enginerrId,val, 11111)
          this.$nextTick(()=>{
            this.changeEngineer(val)
          })
        }
      }
    }
  }
}
</script>
<template>
  <Multiselect
      class="form-control"
      :class="isInvalid ? 'is-invalid' : ''"
      :can-clear="false"
      :can-deselect="false"
      v-model="enginerrId"
      :close-on-select="true"
      :searchable="true"
      :create-option="false"
      value-prop="id"
      label="name"
      :placeholder="placeholoderText"
      :disabled="isDisabled"
      :options="availableEngineer"
      @change="changeEngineer"
  />
</template>
